/**
 *
 * Screen constants
 *
 */

export const INITIALIZE_SCREEN_PROPERTIES = 'claris-vnext/Screen/INITIALIZE_SCREEN_PROPERTIES';
export const CHANGE_BREAKPOINT = 'claris-vnext/Screen/CHANGE_BREAKPOINT';
export const CHANGE_SCREEN_PROPERTIES = 'claris-vnext/Screen/CHANGE_SCREEN_PROPERTIES';
